import type { CustomFieldModel } from '@/types/customField';
import type { User } from '@/types/user';
import { userHasScope } from '@/services/user/userHasScope';

// These UI model aliases share the owning capability used by their field routes.
const fieldCapabilities: Record<CustomFieldModel, string> = {
  order: 'order',
  product: 'product',
  ship_advice: 'ship_advice',
  catalog: 'product',
  inventory_detail: 'inventory',
  channel_item_mapping: 'channel_item_mapping',
  sku_presentation: 'sku_presentation',
  promotion: 'promotion',
  custom_pricing: 'pricing',
};

export const userHasFieldScope = (user: User | null, model: string, action: 'read' | 'create' | 'update' | 'delete'): boolean =>
  Object.prototype.hasOwnProperty.call(fieldCapabilities, model) && userHasScope(user, `${fieldCapabilities[model as CustomFieldModel]}:${action}`);
